import { Box, Button, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import TrainerApproveOrReject from "../../../../views/crd/myworkspace/NewAdmissionRegister/TrainerMapping/TrainerApproveOrReject";
import EditAttendancePerDay from "../../../../views/crd/myworkspace/NewAdmissionRegister/TrainerMapping/EditAttendancePerDay";

export const TrainerDataTableHead = ({navigate,dispatchParams,crm}) => [ 
  {
    field: "sl_no",
    headerName: "Sl No",
    width: 60,
  },
  {
    field: "subject_name",
    headerName: "Subject Name",
    width: 200,
  },
  {
    field: "full_name",
    headerName: "Tutor Name",
    width: 190,
  },

  // {
  //     field: "trainer_alphanum_id",
  //     headerName: "Trainer Alphanum Id",
  //     width: 150,
  // },
  // {
  //     field: "mob_no",
  //     headerName: "Mobile Number",
  //     width: 150,
  // },
  {
    field: "fee_per_session",
    headerName: "Fee Per Session",
    width: 120,
  },
  {
    field: "trainer_payment_per_session",
    headerName: "Tutor Payment",
    width: 130,
  },
  {
    field: "session_duration",
    headerName: "Class Duration",
    width: 110,
  },
  {
    field: "mapping_status",
    headerName: "Mapping Status",
    renderCell: (params) => {
      return params.row.mapping_status === 1 ? (
        <Typography variant="overline" sx={{ color: "success.main" }}>
          Active
        </Typography>
      ) : params.row.mapping_status==2 ? (
        <Typography variant="overline" sx={{ color: "error.main" }}>
          Temporary Inactive
        </Typography>
      ) :(
        <Typography variant="overline" sx={{ color: "error.main" }}>
           Inactive
        </Typography>
      )
    },
    width: 170,
  },
    {
    field: "attendance_per_day",
    headerName: "Attendance Per Day",
    width: 150,
  },
    {
    field: "editAttendance",
    headerName: "Edit Attendance Per Day",
    width: 150,
    renderCell: (params) => <EditAttendancePerDay row={params.row} dispatchParams={dispatchParams} activeType={params.row.mapping_status} crm={crm}/>,
  },
  {
    width: 120,
    field: "action",
    headerName: "Assign Tutor",
    renderCell: (params) => {
      return (
        <Box>
          <Button
            size="small"
            onClick={() => navigate("/my-workspace/assign-trainer",{state:{subjectEnrollmentId:params.row.subject_enrollment_id}})}
            variant="outlined"
            disabled={crm}
          >
            <Icon
              style={{ marginRight: "3px" }}
              icon="material-symbols:right-click-rounded"
              width="20"
              height="20"
            />
            <Typography variant="button">Assign</Typography>
          </Button>
        </Box>
      );
    },
  },
  {
    field: "Verify",
    headerName: "Actions",
    width: 150,
    renderCell: (params) => <TrainerApproveOrReject row={params.row} dispatchParams={dispatchParams} activeType={params.row.mapping_status} crm={crm}/>,
  },
];
